import { IFunding, ProductModel } from '@bytel/leviator';
import { Button, ButtonVariant, Modal, ModalBody, ModalFooter, Spacer, SpacerSize } from '@bytel/trilogy-react';

import { WallType } from '@app-types/config';
import { MobilePlanType } from '@app-types/plan';
import { PriceFundingsDetails, Product, ProductChildFull } from '@app-types/product';

import { Funding, PriceDetailAccessory, PriceDetailHotspot, PriceDetailPhone } from '@components/product-details-modal';

type ProductDetailModalProps = {
    onClose: () => void;
    type: WallType;
    plan?: MobilePlanType | null;
    selectedFunding?: IFunding;
    modalOpen: boolean;
    currentProduct?: { phone: ProductModel; details?: PriceFundingsDetails } | Product | ProductChildFull;
};

export function ProductDetailsModal({
    onClose,
    type,
    plan,
    selectedFunding,
    modalOpen = false,
    currentProduct,
}: Readonly<ProductDetailModalProps>) {
    if (!currentProduct?.details) return null;

    return (
        <Modal active={modalOpen} onClose={onClose} title='Détail du prix'>
            <ModalBody>
                {(type === WallType.PHONE || type === WallType.SALES_PHONE) && (
                    <>
                        <PriceDetailPhone
                            plan={plan}
                            initialPrice={currentProduct.details.price.initial}
                            finalPrice={currentProduct.details.price.final}
                            subsidizedPrice={currentProduct.details.price.subsidized}
                        />
                        <Spacer size={SpacerSize.FOUR} />
                        {currentProduct.details && (
                            <Funding funding={selectedFunding} productDetails={currentProduct.details} />
                        )}
                    </>
                )}
                {(type === WallType.ACCESSORY || type === WallType.SALES_ACCESSORY) && (
                    <PriceDetailAccessory product={currentProduct} />
                )}
                {type === WallType.HOTSPOT && (
                    <PriceDetailHotspot
                        plan={plan}
                        initialPrice={currentProduct.details.price.initial}
                        finalPrice={currentProduct.details.price.final}
                        subsidizedPrice={currentProduct.details.price.subsidized}
                    />
                )}
            </ModalBody>
            <ModalFooter>
                <Button variant={ButtonVariant.PRIMARY} onClick={onClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}
